import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * Formátuje výsledek běžného content builderu pro použití v blocking layer
 * @internal
 */
export class BlockingLayerBuilderDecorator implements IContentBuilder {
    private readonly _baseBuilder: IContentBuilder;
    private _element: HTMLElement | undefined;

    constructor(baseBuilder: IContentBuilder) {
        this._baseBuilder = baseBuilder;
    }

    public async build(): Promise<HTMLElement> {
        if (this._element === undefined) {
            const content = createElement({ classes: "blocking-layer-content" });
            content.appendChild(await this._baseBuilder.build());
            this._element = content;
        }

        return this._element;
    }
}
